/* eslint-disable no-restricted-imports */
import React, { useState, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ModalProgressBar } from '../../../../../../_metronic/_partials/controls';
import * as actions from '../../../_redux/orders/ordersActions';
import { useOrdersUIContext } from '../OrdersUIContext';

export function OrderDeleteDialog({ id, show, onHide }) {
  // Orders UI Context
  //console.log("OrderDeleteDialog", id);
  const ordersUIContext = useOrdersUIContext();
  const ordersUIProps = useMemo(() => {
    return {
      setIds: ordersUIContext.setIds,
      queryParams: ordersUIContext.queryParams,
    };
  }, [ordersUIContext]);
  //const [show, setShow] = useState(false);

  // Orders Redux state
  const dispatch = useDispatch();
  const intl = useIntl();
  const titleText = intl.formatMessage({ id: 'ORDER.CONFIRM.TITLE' });
  const questionText = intl.formatMessage({
    id: 'ORDER.CONFIRM.DELETE.QUESTION',
  });
  const deleteButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.DELETE',
  });
  const cancelButtonText = intl.formatMessage({
    id: 'GENERAL.BUTTON.CANCEL',
  });
  const loadingText = intl.formatMessage({
    id: 'ORDER.CONFIRM.DELETE.LOADING',
  });
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.orders ? state.orders.actionsLoading : false,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    /*  if(match){
      setShow( true);
    } */
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteOrder = () => {
    // server request for deleting order by id
    dispatch(actions.deleteOrder(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchOrders(ordersUIProps.queryParams));
      // closing delete modal
      // clear selections list
      //ordersUIProps.setIds([]);
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'
    >
      {isLoading && <ModalProgressBar variant='query' />}
      <Modal.Header closeButton>
        <Modal.Title id='Orderexample-modal-sizes-title-lg'>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>
            {' '}
            <b>{id}</b> {questionText}
          </span>
        )}
        {isLoading && <span>{loadingText}</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'
          >
            {cancelButtonText}
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteOrder}
            className='btn btn-primary btn-elevate'
          >
            {deleteButtonText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
